import type { InlineMdNode, MenuHandle, Serializer } from '@ui/MarkdownEditor/types';

export const serialize: Serializer<MenuHandle, InlineMdNode[], InlineMdNode[]> = (node, deeper) => {
  return deeper(node);
};
